import './index.scss';
import '../../css/global.css';
import '../../css/normalize.css';

import { useEffect, useState, Fragment, useMemo, useRef } from 'react';
import { Link, useNavigationType } from 'react-router-dom';
import Cabecalho from '../../components/Cabecalho';
import Rodape from '../../components/Rodape';
import CookieAceite from '../../components/CookieAceite';
import api from '../../api';
import { useCart } from '../../context/CartContext.js';
import { useFavorites } from '../../context/FavoritesContext.js';
import { useAuth } from '../../context/AuthContext.js';
import CardProduto from '../../components/CardProd/index.js';

/* Import SEO */
import { SEOHelmet } from '../../hooks/useSEO';
// import { useAnalytics } from '../../hooks/useAnalytics';

export default function Produtos({ prod }) {
    // Inicializar analytics (temporariamente desabilitado)
    // useAnalytics();

    const navigationType = useNavigationType();
    const scrollRestoradoRef = useRef(false);
    const scrollYRef = useRef(0);
    const isPop = navigationType === 'POP';

    const { userId } = useAuth();
    const [categorias, setCategorias] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const [carregandoProdutos, setCarregandoProdutos] = useState(true);
    const [usuario_id, setIdUsuario] = useState();
    const [produtosExibidos, setProdutosExibidos] = useState(() => {
        // Restaura a quantidade de produtos exibidos ao voltar da página de produto
        if (navigationType === 'POP') {
            const saved = Number(sessionStorage.getItem('produtos_exibidos'));
            if (saved > 0) return saved;
        }
        return 50;
    });
    const [filtros, setFiltros] = useState({
        search: '',
        categoria: '',
        marca: '',
        minPrice: 0,
        maxPrice: 0,
        tamanhos: [],
        cores: [],
        material: [],
        estoqueMin: 0,
        estoqueMax: 0,
        pesoMin: 0,
        pesoMax: 0,
        pagina: 1,
        ordem: 'nome_asc',
    });

    const { favorites, toggleFavorite } = useFavorites();
    const [showBackToTop, setShowBackToTop] = useState(false);

    // Salva posição de scroll em uma ref; grava no sessionStorage só no unmount
    // Isso evita que o scrollTo(0) do Link sobrescreva o valor salvo
    useEffect(() => {
        const onScroll = () => { scrollYRef.current = window.scrollY; };
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', onScroll);
            // Ao sair da página, grava a última posição real
            if (scrollYRef.current > 0) {
                sessionStorage.setItem('produtos_scroll', String(scrollYRef.current));
            }
        };
    }, []);

    // Salva quantos produtos estão exibidos para restaurar ao voltar
    useEffect(() => {
        sessionStorage.setItem('produtos_exibidos', String(produtosExibidos));
    }, [produtosExibidos]);

    useEffect(() => {
        let lastScrollY = window.scrollY;
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            const scrollingUp = currentScrollY < lastScrollY;
            setShowBackToTop(scrollingUp && currentScrollY > 400);
            lastScrollY = currentScrollY;
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);


    useEffect(() => {
        async function buscarCategorias() {
            try {
                const res = await api.get('/categoriashierarquicas');
                if (res.data.success) {
                    setCategorias(res.data.categorias);
                }
            } catch (err) {
                console.error('Erro ao buscar categorias:', err);
            }
        }
        buscarCategorias();
    }, []);

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });

                if (response.data.success) {
                    setIdUsuario(response.data.user.id);
                }
            } catch (error) {
                // 401 é esperado para usuários não logados — não logar como erro
                if (error.response?.status !== 401) {
                    console.error('Erro ao buscar dados do usuário:', error);
                }
            }
        };

        buscarDadosUsuario();
    }, []);

    useEffect(() => {
        async function buscarProdutos() {
          setCarregandoProdutos(true);
          try {
            console.log('🔍 Buscando produtos com filtros:', filtros);
                        const response = await api.get('/listarprodutos', { params: { ...filtros, usuario_id } });
                        if (response.data.success) {
                            const prods = (response.data.produtos || []).map(prod => {
                                const valor = Number(prod.preco || prod.preco_varejo || prod.preco_atacado) || 0;
                                return {
                                    ...prod,
                                    id: prod.id_produto ?? prod.id,
                                    preco: valor
                                };
                            });
              console.log('✅ Produtos encontrados:', prods.length);
              setProdutos(prods);
              // Só reseta a quantidade exibida se NÃO for navegação de volta
              if (!isPop) {
                setProdutosExibidos(50);
              }
            } else {
              console.error('❌ Erro ao listar produtos:', response.data.message);
              setProdutos([]);
            }
          } catch (error) {
            console.error('❌ Erro ao buscar produtos:', error);
            setProdutos([]);
          } finally {
            setCarregandoProdutos(false);
          }
        }
        buscarProdutos();
      // isPop é derivado de navigationType que não muda — pode ser omitido sem problemas
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [filtros, usuario_id]);

    // Usa a própria lista (cada item já é uma variação)
    const todasVariacoes = useMemo(() => {
        const variacoes = produtos.filter(Boolean);

        return [...variacoes].sort((a, b) => {
            const semEstoqueA = (Number(a.estoque) || 0) <= 0;
            const semEstoqueB = (Number(b.estoque) || 0) <= 0;

            if (semEstoqueA === semEstoqueB) {
                return 0;
            }

            return semEstoqueA ? 1 : -1;
        });
    }, [produtos]);

    // Produtos a serem exibidos (apenas os primeiros produtosExibidos)
    const produtosListados = useMemo(() => todasVariacoes.slice(0, produtosExibidos), [todasVariacoes, produtosExibidos]);

    // Percentual de progresso
    const percentualProgresso = useMemo(() => 
        todasVariacoes.length > 0 ? Math.round((produtosListados.length / todasVariacoes.length) * 100) : 0,
        [todasVariacoes, produtosListados]
    );

    // Função para carregar mais produtos
    const handleCarregarMais = () => {
        setProdutosExibidos(prev => prev + 50);
    };

    // Restaura scroll ao voltar da página de produto
    // Espera o loading terminar e os cards serem pintados, depois rola
    useEffect(() => {
        if (!isPop) return;
        if (scrollRestoradoRef.current) return;
        if (carregandoProdutos) return;
        if (produtosListados.length === 0) return;

        const savedScroll = Number(sessionStorage.getItem('produtos_scroll'));
        if (!savedScroll) return;

        // Polling: espera o DOM ter altura suficiente para rolar
        const interval = setInterval(() => {
            const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
            if (maxScroll >= savedScroll * 0.8) {
                window.scrollTo({ top: savedScroll });
                scrollRestoradoRef.current = true;
                clearInterval(interval);
            }
        }, 50);

        const timeout = setTimeout(() => clearInterval(interval), 6000);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, [isPop, produtosListados, carregandoProdutos]);

    const tamanhosDisponiveis = useMemo(
        () => [...new Set(todasVariacoes.map(v => v.tamanho).filter(Boolean))].sort(),
        [todasVariacoes]
    );
    const coresDisponiveis = useMemo(
        () => [...new Set(todasVariacoes.map(v => v.cor).filter(Boolean))].sort(),
        [todasVariacoes]
    );
    const materiaisDisponiveis = useMemo(
        () => [...new Set(todasVariacoes.map(v => v.material).filter(Boolean))].sort(),
        [todasVariacoes]
    );

    const precos = useMemo(
        () => todasVariacoes.map(v => Number(v.preco) || 0),
        [todasVariacoes]
    );
    const estoques = useMemo(
        () => todasVariacoes.map(v => v.estoque || 0),
        [todasVariacoes]
    );
    const pesos = useMemo(
        () => todasVariacoes.map(v => Number(v.peso) || 0),
        [todasVariacoes]
    );

    const minPreco = useMemo(() => Math.min(...precos, 0), [precos]);
    const maxPreco = useMemo(() => Math.max(...precos, 0), [precos]);
    const minEstoque = useMemo(() => Math.min(...estoques, 0), [estoques]);
    const maxEstoque = useMemo(() => Math.max(...estoques, 0), [estoques]);
    const minPeso = useMemo(() => Math.min(...pesos, 0), [pesos]);
    const maxPeso = useMemo(() => Math.max(...pesos, 0), [pesos]);

    // Handler para categoria (select único)
    function handleCategoriaChange(e) {
        const { value } = e.target;
        setFiltros(prev => ({ ...prev, categoria: value, pagina: 1 }));
    }

    // Handler para checkboxes e inputs
    function handleInputChange(e) {
        const { name, value, type, checked } = e.target;
        console.log(`📝 Filtro alterado: ${name} = ${type === 'checkbox' ? checked : value}`);
        if (type === 'checkbox') {
            setFiltros(prev => {
                const setItems = new Set(prev[name] || []);
                checked ? setItems.add(value) : setItems.delete(value);
                const newState = { ...prev, [name]: [...setItems], pagina: 1 };
                console.log('✏️ Novo estado de filtros:', newState);
                return newState;
            });
        } else {
            setFiltros(prev => {
                const newState = { ...prev, [name]: value, pagina: 1 };
                console.log('✏️ Novo estado de filtros:', newState);
                return newState;
            });
        }
    }

    // Limpar filtros
    function limparFiltros() {
        setFiltros({
            search: '',
            categoria: '',
            marca: '',
            minPrice: 0,
            maxPrice: 999999,
            tamanhos: [],
            cores: [],
            material: [],
            estoqueMin: 0,
            estoqueMax: 999999,
            pesoMin: 0,
            pesoMax: 999999,
            pagina: 1,
            ordem: 'nome_asc',
        });
    }

    function renderCategoriaOptions(list, depth = 0) {
        return list.map(cat => (
            <Fragment key={cat.id}>
                <option value={cat.id}>
                    {Array(depth).fill('\u00A0\u00A0').join('')}{cat.nome}
                </option>
                {cat.subcategorias?.length > 0 && renderCategoriaOptions(cat.subcategorias, depth + 1)}
            </Fragment>
        ));
    }

    return (
        <section className="containerPrincipalProduto">
            <SEOHelmet
                title="Produtos - Fracaro Store | Jogos de Cama, Mesa e Banho"
                description="Confira nosso catálogo completo de jogos de cama, mesa e banho de alta qualidade. Mais de 150 produtos disponíveis com entrega rápida em São Paulo."
                keywords="produtos, jogos de cama, mesa e banho, decoração, qualidade, frete grátis"
                url={window.location.href}
            />
            <Cabecalho />
            <CookieAceite />

            <main className="produtos-main">
                <aside className="filtros-sidebar">
                    <h2 className="filters-title">Filtros</h2>

                    <details open className="filter-group">
                        <summary>Categorias</summary>
                        <div className="options-grid">
                            <select
                                name="categoria"
                                value={filtros.categoria}
                                onChange={handleCategoriaChange}
                                style={{
                                    width: '100%',
                                    padding: '8px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    fontFamily: 'Lexend-Regular',
                                    cursor: 'pointer'
                                }}
                            >
                                <option value="">Todas as categorias</option>
                                {renderCategoriaOptions(categorias)}
                            </select>
                        </div>
                    </details>

                    <details open className="filter-group">
                        <summary>Tamanhos</summary>
                        <div className="options-grid">
                            {tamanhosDisponiveis.map(t => (
                                <label key={t} className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        name="tamanhos"
                                        value={t}
                                        checked={filtros.tamanhos.includes(t)}
                                        onChange={handleInputChange}
                                    />
                                    {t}
                                </label>
                            ))}
                        </div>
                    </details>

                    <details open className="filter-group">
                        <summary>Cores</summary>
                        <div className="options-grid">
                            {coresDisponiveis.map(c => (
                                <label key={c} className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        name="cores"
                                        value={c}
                                        checked={filtros.cores.includes(c)}
                                        onChange={handleInputChange}
                                    />
                                    {c}
                                </label>
                            ))}
                        </div>
                    </details>

                    <details open className="filter-group">
                        <summary>Material</summary>
                        <div className="options-grid">
                            {materiaisDisponiveis.map(m => (
                                <label key={m} className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        name="material"
                                        value={m}
                                        checked={filtros.material.includes(m)}
                                        onChange={handleInputChange}
                                    />
                                    {m}
                                </label>
                            ))}
                        </div>
                    </details>


                    <details open className="filter-group">
                        <summary>Preço</summary>
                        <div className="range-single">
                            <label>
                                <span>R$ {filtros.minPrice}</span>
                                <input
                                    type="range"
                                    name="minPrice"
                                    min={minPreco}
                                    max={maxPreco}
                                    value={filtros.minPrice}
                                    onChange={handleInputChange}
                                />
                            </label>
                            <label>
                                <span>R$ {filtros.maxPrice}</span>
                                <input
                                    type="range"
                                    name="maxPrice"
                                    min={minPreco}
                                    max={maxPreco}
                                    value={filtros.maxPrice}
                                    onChange={handleInputChange}
                                />
                            </label>
                        </div>
                    </details>

                    <details className="filter-group">
                        <summary>Estoque</summary>
                        <div className="range-single">
                            <label>
                                <span>{filtros.estoqueMin} – {filtros.estoqueMax}</span>
                                <input
                                    type="range"
                                    name="estoqueMin"
                                    min={minEstoque}
                                    max={maxEstoque}
                                    value={filtros.estoqueMin}
                                    onChange={handleInputChange}
                                />
                            </label>
                        </div>
                    </details>

                    <details className="filter-group">
                        <summary>Peso</summary>
                        <div className="range-single">
                            <label>
                                <span>{filtros.pesoMin}kg – {filtros.pesoMax}kg</span>
                                <input
                                    type="range"
                                    name="pesoMin"
                                    min={minPeso}
                                    max={maxPeso}
                                    value={filtros.pesoMin}
                                    onChange={handleInputChange}
                                />
                            </label>
                        </div>
                    </details>

                    <button className="btn-clear" onClick={limparFiltros}>
                        Limpar filtros
                    </button>
                </aside>

                <section className="produtos-lista">
                    <div className='titulo-produtos'>
                        <h1>Catálogo de produtos</h1>
                        <hr></hr>
                    </div>
                    <div className='container-pesquisas'>
                        <div className="input-filtro">
                            <select
                                name="ordem"
                                value={filtros.ordem}
                                onChange={handleInputChange}
                            >
                                <option value="nome_asc">Nome (A-Z)</option>
                                <option value="preco_asc">Menor preço</option>
                                <option value="preco_desc">Maior preço</option>
                            </select>
                        </div>
                    </div>

                    <div className="grid-produtos">
                        {carregandoProdutos ? (
                            <div className="loading-produtos">
                                <svg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 24 24'>
                                    <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                                    <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                                        <animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                                    </path>
                                </svg>
                                <h2>Carregando produtos...</h2>
                            </div>
                        ) : produtosListados.length > 0 ? (
                            produtosListados.map(prod => (
                                <CardProduto
                                    key={`${prod.id_produto || prod.id}-${prod.id_variacao || ''}`}
                                    prod={{
                                        ...prod,
                                        id: prod.id_produto || prod.id,
                                        id_variacao: prod.id_variacao,
                                        preco: prod.preco,
                                    }}
                                />
                            ))
                        ) : (
                            <p>Nenhum produto disponível.</p>
                        )}
                    </div>

                    {/* Contador e Barra de Progresso */}
                    {todasVariacoes.length > 0 && (
                        <div className="carregador-mais-container">
                            <button 
                                className="btn-carregar-mais"
                                onClick={handleCarregarMais}
                                disabled={produtosExibidos >= todasVariacoes.length}
                            >
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 15.8333L10 4.16665M10 15.8333L5 10.8333M10 15.8333L15 10.8333" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/></svg> Carregar Mais
                            </button>
                            
                            <div className="progresso-info">
                            <div className={`barra-progresso ${produtosExibidos >= todasVariacoes.length ? 'completa' : ''}`}>
                                <div 
                                    className="barra-progresso-fill"
                                    style={{ width: `${percentualProgresso}%` }}
                                />
                            </div>
                                <span className="contador">
                                    {produtosListados.length} de {todasVariacoes.length} produtos
                                </span>
                            </div>
                        </div>
                    )}
                </section>
            </main>

            {showBackToTop && (
                <button
                    className="btn-voltar-topo-fixo"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    title="Voltar ao topo"
                >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 4.16665L10 15.8333M10 4.16665L5 9.16665M10 4.16665L15 9.16665" stroke="white" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    Voltar ao topo
                </button>
            )}
            <Rodape />
        </section>
    );
}